/* Star Rating Component for Forms */

export function initFormRating() {
  // Star rating interactivity
  document.querySelectorAll('.rating-star').forEach(star => {
    star.addEventListener('click', function() {
      if (this.disabled) return;

      const rating = parseInt(this.dataset.rating);
      const fieldName = this.dataset.field;
      const container = this.parentElement;
      const hiddenInput = container.querySelector('input[type="hidden"]') ||
                         document.getElementById(fieldName) ||
                         document.getElementById(`field_${fieldName}`);

      if (!hiddenInput) {
        console.error(`Hidden input not found for field: ${fieldName}`);
        return;
      }

      // Update hidden input value
      hiddenInput.value = rating;

      // Update star appearances
      updateStars(container, rating);
    });

    // Hover effect
    star.addEventListener('mouseenter', function() {
      if (this.disabled) return;

      const rating = parseInt(this.dataset.rating);
      const container = this.parentElement;
      updateStars(container, rating);
    });

    star.addEventListener('mouseleave', function() {
      if (this.disabled) return;

      const fieldName = this.dataset.field;
      const container = this.parentElement;
      const hiddenInput = container.querySelector('input[type="hidden"]') ||
                         document.getElementById(fieldName) ||
                         document.getElementById(`field_${fieldName}`);

      const currentRating = parseInt(hiddenInput?.value) || 0;
      updateStars(container, currentRating);
    });
  });

  // Initialize star ratings from existing values
  initializeStarValues();
}

function updateStars(container, rating) {
  const allStars = container.querySelectorAll('.rating-star');
  allStars.forEach((star, index) => {
    if (index < rating) {
      star.classList.remove('text-gray-400');
      star.classList.add('text-yellow-400');
    } else {
      star.classList.remove('text-yellow-400');
      star.classList.add('text-gray-400');
    }
  });
}

function initializeStarValues() {
  // Find all rating containers and initialize from hidden input values
  document.querySelectorAll('[data-controller="rating"], .rating-star').forEach(element => {
    const container = element.classList.contains('rating-star')
      ? element.parentElement
      : element;

    const hiddenInput = container.querySelector('input[type="hidden"]');
    if (hiddenInput && hiddenInput.value) {
      const rating = parseInt(hiddenInput.value);
      updateStars(container, rating);
    }
  });
}

// Export for use in other modules
export { updateStars, initializeStarValues };
